export default __webpack_public_path__ + "static/media/Fosun - Logo2.da1c9f76.png";